import React from 'react';
import { Box, Container, Typography, Grid, Stack, Chip } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { C, Section, SectionLabel } from './theme';

const points = [
  'Live keyword rank tracking, before vs after',
  'Every backlink URL, anchor text, and authority score',
  'Downloadable PDF report for your own records or clients',
  'Available anytime from your account\u2019s Orders page',
];

const SampleReport = () => (
  <Section id="report" sx={{ background: C.bgSection, borderBottom: `1px solid ${C.border}` }}>
    <Container maxWidth="lg">
      <Grid container spacing={{ xs: 5, md: 6 }} alignItems="center">
        <Grid size={{ xs: 12, md: 6 }}>
          <Box component="img" src="/assets/banner-sec-img.png" alt="Sample keyword ranking report"
            sx={{ width: '100%', height: 'auto', borderRadius: '16px', display: 'block', boxShadow: '0 12px 34px rgba(23,11,51,0.10)' }} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <SectionLabel>Full Transparency</SectionLabel>
          <Typography variant="h2" sx={{
            fontWeight: 800, fontSize: { xs: '1.85rem', md: '2.4rem' },
            color: C.textPrimary, letterSpacing: '-0.03em', mb: 2,
          }}>
            See exactly what you're paying for
          </Typography>
          <Typography sx={{ color: C.textSecondary, fontSize: '1rem', lineHeight: 1.65, mb: 3.5 }}>
            No vague promises. Every campaign comes with a clear, detailed report so you always
            know where your links live and how your rankings are trending.
          </Typography>
          <Stack spacing={1.75}>
            {points.map((p) => (
              <Stack key={p} direction="row" spacing={1.5} alignItems="center">
                <CheckCircle sx={{ color: C.success, fontSize: 20 }} />
                <Typography sx={{ color: C.textPrimary, fontWeight: 600, fontSize: '0.94rem' }}>{p}</Typography>
              </Stack>
            ))}
          </Stack>
          <Chip label="Sample report shown above" size="small" sx={{
            mt: 3, background: C.primaryLight, color: C.primary, fontWeight: 700,
            border: `1px solid ${C.primary}30`,
          }} />
        </Grid>
      </Grid>
    </Container>
  </Section>
);

export default SampleReport;
